<div class="container-block-map">
    <aside class="block-schedule">
        <rwidget-ondemand-trips></rwidget-ondemand-trips>
    </aside>

    <div class="block-schedule-map" [ngClass]="{ 'full-map': isFullMap }">
        <div class="show-mobile hide-desktop">
            <div class="map-overlay-mobile" [ngClass]="{ hidden: isFullMap }" (click)="toggleMapSize()"></div>
        </div>

        <div class="flex-center" *ngIf="isFullMap">
            <button class="increase-map" (click)="toggleMapSize()">
                <span *ngIf="!isFullMap">{{ 'SCHEDULE_MAP_INCREASE_TITLE' | translate }}</span>
                <span *ngIf="isFullMap">{{ 'SCHEDULE_MAP_DECREASE_TITLE' | translate }}</span>
            </button>
        </div>
        <rwidget-map
            [latitude]="mapCenter.latitude"
            [longitude]="mapCenter.longitude"
            [hasControls]="true"
            [fullMap]="isFullMap"
            [allowPointClick]="false">
            <rwidget-map-polyline *ngIf="polyline$ | async" [encodedPath]="polyline$ | async" [color]="polylineColor">
            </rwidget-map-polyline>

            <rwidget-map-marker
                *ngIf="pickUp"
                [latitude]="pickUp.latitude"
                [longitude]="pickUp.longitude"
                [isSingle]="true">
                <rwidget-map-icon [url]="iconOrigin" [size]="[18, 24]" [anchor]="[9, 24]"></rwidget-map-icon>
            </rwidget-map-marker>

            <rwidget-map-marker
                *ngIf="dropOff"
                [latitude]="dropOff.latitude"
                [longitude]="dropOff.longitude"
                [isSingle]="true">
                <rwidget-map-icon [url]="iconDestination" [size]="[24, 24]"></rwidget-map-icon>
            </rwidget-map-marker>

            <rwidget-map-layer-group [label]="'SCHEDULE_STOPS_LAYER' | translate" [showOnMap]="true">
                <rwidget-map-marker-group
                    [markers]="potentialStops$ | async"
                    [deleteOld]="true"
                    (markerClicked)="onStopClicked($event)">
                    <rwidget-map-icon [url]="iconStop" [anchor]="[18, 44]" [size]="[36, 44]"> </rwidget-map-icon>
                    <rwidget-map-popup>
                        <div class="popup-title text-base">
                            <p>
                                {{ clickedStop?.address }}
                                <ng-container *ngIf="clickedStop?.direction">
                                    ({{ clickedStop.direction }})
                                </ng-container>
                            </p>
                        </div>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>
            </rwidget-map-layer-group>

            <rwidget-map-locator></rwidget-map-locator>
        </rwidget-map>
    </div>
</div>
